// src/pages/MemeIssuePage.jsx
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import api from "../services/api";

const MemeIssuePage = () => {
  const [caption, setCaption] = useState("");
  const [image, setImage] = useState(null);
  const [memes, setMemes] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/memes").then((res) => setMemes(res.data));
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!image) return;
    const formData = new FormData();
    formData.append("image", image);
    formData.append("caption", caption);

    setLoading(true);
    try {
      const res = await api.post("/memes/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMemes([res.data, ...memes]);
      setCaption("");
      setImage(null);
      setPreviewUrl(null);
    } catch (err) {
      console.error("Meme upload failed", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white shadow-md p-6 rounded-xl">
        <h1 className="text-3xl font-bold text-center text-blue-800 mb-2">
          Raise an Issue with a Meme
        </h1>
        <p className="text-sm text-gray-600 text-center mb-4 italic">
          Upload a meme about your local issue – Make it funny, make it viral!
        </p>

        <div className="space-y-4">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="w-full border p-2 rounded"
          />
          <input
            type="text"
            placeholder="Enter a witty caption..."
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
            className="w-full border p-2 rounded"
          />
          {previewUrl && (
            <img
              src={previewUrl}
              alt="Preview"
              className="w-full max-h-64 object-contain rounded border"
            />
          )}
          <button
            onClick={handleUpload}
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded shadow"
          >
            {loading ? "Uploading..." : "Upload Meme"}
          </button>
        </div>
      </div>

      <div className="max-w-4xl mx-auto mt-10">
        <h2 className="text-xl font-semibold mb-4 text-gray-800">
          Latest Meme Issues
        </h2>
        <div className="grid sm:grid-cols-2 gap-6">
          {memes.length === 0 ? (
            <p>No meme issues yet. Be the first to raise one!</p>
          ) : (
            memes.map((meme, idx) => (
              <motion.div
                key={idx}
                whileHover={{ scale: 1.02 }}
                className="bg-white p-4 rounded-xl shadow border"
              >
                <img
                  src={meme.imageUrl}
                  alt="Meme"
                  className="w-full h-64 object-cover rounded mb-2"
                />
                <p className="text-sm text-gray-700">{meme.caption}</p>
                <p className="text-xs text-gray-400 mt-1">Uploaded on: {new Date(meme.createdAt).toLocaleDateString()}</p>
              </motion.div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default MemeIssuePage;
